import type { CampaignCardView } from "../../../shared/types/campaign-card.type";

const STALE_STATUSES = new Set(["PAUSED", "BANNED", "REMOVED"]);

type Props = {
	campaign: CampaignCardView;
};

export const CampaignBanners = ({ campaign }: Props) => {
	const isStale = STALE_STATUSES.has(campaign.status.toUpperCase());

	if (!isStale) return null;

	return (
		<div className='campaign-detail__banner campaign-detail__banner--warning'>
			Кампанія у статусі {campaign.status} — метрики Google Ads неактуальні
		</div>
	);
};
